// React Query hook for the Phase-2 activity detail endpoint
// (GET /manage/schedule/activity/{activityId}). Follows the
// useSchedule pattern: a single useQuery keyed on the activity id,
// delegating to scheduleApi.activityDetail (typed so the
// untyped-apiRequest Promise<{}> gotcha is avoided). Disabled until an
// id is present (the drawer is closed when there's no ?activity=).
// Cached for the page duration (spec §4.3) — the default React Query
// staleness is fine here since the detail is read-only in Phase 2
// (edit-in-drawer is Phase 4, out of scope).

import { useQuery } from "@tanstack/react-query";
import { scheduleApi } from "../services/api";

export function useActivityDetail(activityId: string | undefined) {
  return useQuery({
    queryKey: ["schedule", "activity", activityId],
    queryFn: () => scheduleApi.activityDetail(activityId as string),
    enabled: !!activityId,
  });
}
